import { clearGbpOauthResume } from './gbpOauthResume';
import { supabase } from './supabaseClient';

const SESSION_KEYS = [
  'gbp_connect_business_id',
  'gbp_connect_profile_id',
  'gbp_connect_return_path',
  'gbp_open_settings',
  'gbp_google_linking',
] as const;

/** Clear browser session leftovers from a GBP OAuth attempt. */
export function clearGbpConnectSession(): void {
  try {
    for (const key of SESSION_KEYS) sessionStorage.removeItem(key);
    clearGbpOauthResume();
  } catch {
    /* ignore */
  }
}

/**
 * Wipe unfinished / failed GBP connect state for a business so the UI looks
 * like it was never connected (no Reconnect / Finalize leftovers).
 */
export async function resetGbpConnectState(businessId: string): Promise<void> {
  if (!businessId) {
    clearGbpConnectSession();
    return;
  }
  try {
    await supabase.functions.invoke('ayrshare-gbp-disconnect', {
      body: { businessId, action: 'reset' },
    });
  } catch (err) {
    console.warn('[gbp] reset pending connection failed:', err);
  }
  clearGbpConnectSession();
}
